import { useState, useEffect } from "react";
import axios from "axios";
import { local_backend } from '../config';

// Module-level singleton cache ✅
let cachedUser = null;
let cachedIsAdmin = null;
let fetchPromise = null; // prevent duplicate fetch calls

const useUser = () => {
  const [user, setUser] = useState(cachedUser);
  const [isAdmin, setIsAdmin] = useState(cachedIsAdmin);

  const getAllAccessUsers = async () => {
    // If data is already loading, wait for it
    if (fetchPromise) return fetchPromise;

    // Start fetching
    fetchPromise = axios
      .get(`${local_backend}OpenAPI/GetAllAccessUsers`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const admins = response.data
          .map((n) => n.accessEmail?.toLowerCase())
          .filter(Boolean);

        const loggedUser = JSON.parse(localStorage.getItem("kps-user"));

        cachedUser = loggedUser;
        cachedIsAdmin = admins.includes(loggedUser?.account?.username?.toLowerCase());

        return { user: cachedUser, isAdmin: cachedIsAdmin };
      })
      .catch((err) => {
        console.error("useUser error:", err);
        cachedUser = null;
        cachedIsAdmin = false;
      });

    return fetchPromise;
  };

  useEffect(() => {
    if (cachedUser !== null && cachedIsAdmin !== null) return;

    getAllAccessUsers().then((data) => {
      if (data) {
        setUser(data.user);
        setIsAdmin(data.isAdmin);
      }
    });
  }, []);

  return { user, isAdmin };
};

export default useUser;
